var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"text-center"},[_c('b-card',[_c('b-spinner'),_c('p',[_vm._v("Carregando...")])],1)],1):_vm._e(),(!_vm.isLoading)?_c('div',{class:{
      'pointer-events-none': _vm.isSubmiting
    }},[_c('account-list',{attrs:{"show-filters":false,"user-id":_vm.userId}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }